import React , {useEffect,useState} from "react";
import StudentAwardsControl from './awards'
import { useAuth } from "../../../usercontext";
import { useParams } from "react-router-dom";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import Student911TopMenu from "../../instructor/studentInfo/student911topmenu";
import GlobalStudentProgressCheck from "../../pages/common/globalstudentprogresscheck";



const StudentGoalTracker = () => {
   const { slug } = useParams();
  const { profile } = useAuth();
  //const slug = profile.id;
  const studentId = profile.role === "Instructor" ? slug : profile.id;
  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  const isInsractor =  profile?.role === "Instructor"

  return (
    <>
        {isInsractor && <Student911TopMenu slug={studentId} activeMenu={"Awards"} /> }
           {/* {isInsractor && <Student12TopMenu slug={slug} activeMenu={"Awards"} /> }      */}
      {(!isInsractor) && isStudent && <STopMenu slug={studentId} activeMenu="Activities" />}
        {(!isInsractor) && isStudent911 && <S911TopMenu slug={studentId} activeMenu="Activities" />}
        {(!isInsractor) && isStudent12 && <S12TopMenu slug={studentId} activeMenu="Activities" />}
      <StudentAwardsControl />
       <div className="tak-instruct-group">
              <div className="row">
                <div className="col-md-12">
                  <GlobalStudentProgressCheck studentId={slug} type={"Awards"} />
                </div>
              </div>
            </div>
    </>
  )
}

export default StudentGoalTracker;